<div class="bg">
    <div class="pddj-page-header">
        <h2>Select Deal</h2>
    </div>

    <div class="message-wrap">
        <div class="message">
            {{ setText() }}
        </div>
    </div>

    <search-bar [isFiltered]="isFiltered" (outEvent)="eventHandler($event)"> </search-bar>

    <div class="tab-container">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedIndexChange)="selectDealType($event)">
            <mat-tab label="Open Deals"></mat-tab>
            <mat-tab label="Closed Deals"></mat-tab>
        </mat-tab-group>
    </div>

    <div id="deals" [style]="isLoading ? 'background-color: #ffffff50; justify-content: center;' : ''" class="pddj-deals-container">
        <three-dot-loader *ngIf="isLoading; else loaded"></three-dot-loader>

        <ng-template #loaded
            ><dealer-deal-card *ngFor="let deal of deals" [deal]="deal">
                <div class="add-doc-container">
                    <button mat-button [routerLink]="dealUrl" class="pddj-add-document">Add Document</button>
                </div>
            </dealer-deal-card></ng-template
        >
    </div>
    <div class="paginator-wrap">
        <ng-container *ngIf="totalNumberOfDeals > 20">
            <mat-paginator [length]="totalNumberOfDeals" [pageSize]="20" [pageSizeOptions]="[5, 10, 25, 100]" (page)="onPageChange($event)"> </mat-paginator>
        </ng-container>
    </div>
</div>
